<template>
	<div
		v-if="type === 'phone'"
		@click="copyPhone"
		class='cursor-pointer'
	>
		<slot></slot>
	</div>

	<a
		target='_blank'
		v-else-if="type === 'link'"
		:href='value'
		class='text-decoration-none'
	>
		<slot></slot>
	</a>

	<a
		v-else-if="type === 'email'"
		:href='value'
		class='text-decoration-none'
	>
		<slot></slot>
	</a>

	<router-link
		v-else-if="type === 'fileList'"
		:to="{
			name: 'event-actions-by-id',
			params: {
				eventId: this.$route.params.id,
				actionId: actionId
			},
			query: {
				title: action.action_name
			}
		}"
		class="text-decoration-none text--black"
	>
		<slot></slot>
	</router-link>

	<router-link
		v-else-if="type === 'linkList'"
		:to="{
			name: 'event-actions-by-id',
			params: {
				eventId: this.$route.params.id,
				actionId: actionId
			},
			query: {
				title: action.action_name
			}
		}"
		class="text-decoration-none text--black"
	>
		<slot></slot>
	</router-link>
</template>

<script>
import Vue from 'vue'
import VueScrollTo from 'vue-scrollto'
import Avatar from '@/components/Avatar.vue'
import ResourceList from '@/components/Resource/ResourceList.vue'
import SessionAttachments from '@/components/Resource/SessionAttachments.vue'
import { mapActions, mapGetters } from 'vuex'
import VueClipboard from 'vue-clipboard2'

Vue.use(VueClipboard);
Vue.use(VueScrollTo);

export default {
	name: 'ActionPreview',
	components: { SessionAttachments, ResourceList, Avatar },

	props: {
		action: {
			type: Object,
			default: () => {},
		},
	},

	data() {
		return {
			successMessage: ''
		}
	},

	computed: {
		...mapGetters('app', ['isShowAlert', 'alertMessage']),

		type() {
			const {action_type: type} = this.action || {}
			return String(type);
		},
		value() {
			const {action_value: value} = this.action || {}
			return value
		},
		actionId() {
			const {action_id: value} = this.action || {}
			return value
		}
	},

	methods: {
		...mapActions('app', ['showAlert', 'hideAlert']),

		copyPhone() {
			if (!this.isShowAlert) {
				const phone = this.value.replace(/\D/g, '');

				this.$copyText( phone ).then(() => {
					const closeTimeout = setTimeout(() => {
						this.hideAlert('')
					}, 3000)

					this.showAlert({ message: 'Phone number copied successfully.', closeTimeout })
				})
			}


		},
	},
}
</script>

<style lang="scss">
.cursor-pointer {
	cursor: pointer;
}
</style>
